import { UiPalette } from '@eiq/ui';

import { ResearchStatus } from './research-status.enum';

export const ResearchStatusLabels: Record<ResearchStatus, string> = {
  [ResearchStatus.Draft]: 'Draft',
  [ResearchStatus.Live]: 'Live',
  [ResearchStatus.Offline]: 'Offline',
  [ResearchStatus.Closed]: 'Closed',
  [ResearchStatus.LiveEditing]: 'Live Editing'
};

export const ResearchStatusBadge: Record<ResearchStatus, UiPalette> = {
  [ResearchStatus.Draft]: 'alert',
  [ResearchStatus.Live]: 'success',
  [ResearchStatus.Offline]: 'warn',
  [ResearchStatus.Closed]: 'warn',
  [ResearchStatus.LiveEditing]: 'alert'
};
